/**
 * Settings constants - Single source of truth for UI options
 */

// Tabs configuration
export const SETTINGS_TABS = [
  { id: 'social', label: 'Réseaux sociaux', icon: 'Share2' },
  { id: 'stock_import', label: 'Stock & Import', icon: 'Download' },
  { id: 'vitrine', label: 'Vitrine', icon: 'Globe' },
  { id: 'company', label: 'Mon entreprise', icon: 'Building2' },
  { id: 'subscription', label: 'Abonnement', icon: 'CreditCard' },
];

// Tone options for AI content
export const TONE_OPTIONS = [
  { value: 'professional', label: 'Professionnel' },
  { value: 'friendly', label: 'Amical' },
  { value: 'dynamic', label: 'Dynamique' },
];

// Font styles
export const FONT_STYLES = [
  { id: 'modern', name: 'Moderne', font: 'Montserrat, system-ui', desc: 'Épuré & lisible', sample: 'Mercedes-AMG' },
  { id: 'elegant', name: 'Élégant', font: '"Playfair Display", Georgia', desc: 'Classique & raffiné', sample: 'Mercedes-AMG' },
  { id: 'impact', name: 'Impact', font: '"Bebas Neue", Impact', desc: 'Accrocheur & bold', sample: 'MERCEDES-AMG' },
];

// Badge configurations
export const BADGE_CONFIGS = {
  nouveaute: { text: 'NOUVEAUTÉ', bg: '#2a2a2e', fg: '#a0a0a0' },
  vendu: { text: 'VENDU', bg: '#2a2a2e', fg: '#a0a0a0' },
  promo: { text: '-15% PROMO', bg: '#2a2a2e', fg: '#a0a0a0' },
  garantie: { text: 'GARANTIE 12 MOIS', bg: '#2a2a2e', fg: '#a0a0a0' },
  reprise: { text: 'REPRISE POSSIBLE', bg: '#2a2a2e', fg: '#a0a0a0' },
};

// Story info toggles
export const STORY_INFO_TOGGLES = [
  { key: 'story_show_fuel', icon: 'Fuel', label: 'Carburant' },
  { key: 'story_show_transmission', icon: 'Gauge', label: 'Transmission' },
  { key: 'story_show_year', icon: 'CalendarDays', label: 'Année' },
  { key: 'story_show_mileage', icon: 'Car', label: 'Kilométrage' },
];

// Size sliders for stories
export const SIZE_SLIDERS = [
  { key: 'story_catchphrase_size', label: 'Accroche' },
  { key: 'story_vehicle_size', label: 'Véhicule' },
  { key: 'story_price_size', label: 'Prix' },
  { key: 'story_info_size', label: 'Infos' },
];

// Color fields for stories
export const COLOR_FIELDS = [
  { key: 'story_bg_color', label: 'Fond', default: '#1a1a2e' },
  { key: 'story_catchphrase_color', label: 'Accroche', default: '#cccccc' },
  { key: 'story_make_color', label: 'Marque', default: '#ffffff' },
  { key: 'story_model_color', label: 'Modèle', default: '#ffffff' },
  { key: 'story_accent_color', label: 'Prix', default: '#4ade80' },
  { key: 'story_info_color', label: 'Infos', default: '#999999' },
  { key: 'story_badge_bg_color', label: 'Badge', default: '#ef4444' },
  { key: 'story_badge_text_color', label: 'Badge txt', default: '#ffffff' },
];

// Ad platforms (visibility card toggles)
export const AD_PLATFORMS = [
  { id: '2ememain', name: '2ememain' },
  { id: 'gocar', name: 'GoCar.be' },
  { id: 'autoscout24', name: 'AutoScout24' },
  { id: 'facebook_marketplace', name: 'Facebook Marketplace' },
  { id: 'carmin_marketplace', name: 'Marketplace Carmin' },
];

// Watermark positions
export const WATERMARK_POSITIONS = [
  { value: 'bottom-right', label: 'En bas à droite' },
  { value: 'bottom-left', label: 'En bas à gauche' },
  { value: 'top-right', label: 'En haut à droite' },
  { value: 'top-left', label: 'En haut à gauche' },
];

// Publishing platforms
export const PLATFORMS = [
  {
    id: 'instagram',
    name: 'Instagram',
    options: [
      { key: 'publish_instagram_story', label: 'Stories', desc: 'Format vertical 9:16' },
      { key: 'publish_instagram_post', label: 'Posts', desc: 'Format carré ou 4:5' },
    ]
  },
  {
    id: 'facebook',
    name: 'Facebook',
    options: [
      { key: 'publish_facebook_post', label: 'Posts', desc: 'Publications sur votre page' },
    ]
  },
];

// Publication channels (platform × format combinations)
export const PUBLICATION_CHANNELS = [
  { id: 'instagram_post', settingsKey: 'publish_instagram_post', platform: 'instagram', format: 'feed', label: 'IG Feed', shortLabel: 'Feed' },
  { id: 'instagram_story', settingsKey: 'publish_instagram_story', platform: 'instagram', format: 'story', label: 'IG Story', shortLabel: 'Story' },
  { id: 'facebook_post', settingsKey: 'publish_facebook_post', platform: 'facebook', format: 'feed', label: 'FB Post', shortLabel: 'Post' },
];

// Publication event types for the event × channel matrix
export const PUBLICATION_EVENT_TYPES = [
  { id: 'new_vehicle', label: 'Nouveau véhicule', icon: 'Car' },
  { id: 'price_reduction', label: 'Réduction de prix', icon: 'TrendingDown' },
  { id: 'sold_vehicle', label: 'Véhicule vendu', icon: 'CheckCircle' },
];

// Default publication events config (all channels active for new_vehicle, stories only for others)
export const DEFAULT_PUBLICATION_EVENTS = {
  new_vehicle: { instagram_post: true, instagram_story: true, facebook_post: true },
  price_reduction: { instagram_post: false, instagram_story: true, facebook_post: false },
  sold_vehicle: { instagram_post: false, instagram_story: true, facebook_post: false },
};

// Delay options between publications
export const DELAY_OPTIONS = [
  { value: 5, label: '5 minutes' },
  { value: 15, label: '15 minutes' },
  { value: 30, label: '30 minutes' },
  { value: 60, label: '1 heure' },
  { value: 90, label: '1h30' },
  { value: 120, label: '2 heures' },
  { value: 180, label: '3 heures' },
  { value: 240, label: '4 heures' },
];

// Badge shapes
export const BADGE_SHAPES = [
  { id: 'rounded', label: 'Arrondi' },
  { id: 'pill', label: 'Pilule' },
  { id: 'square', label: 'Carré' },
];

// Max publications per day options
export const MAX_PUBLICATIONS_OPTIONS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

// Story event types (sub-tabs in Stories settings - used for tab rendering only)
export const STORY_EVENT_TYPES = [
  { id: 'new_vehicle', label: 'Nouvelle voiture', icon: 'Car' },
  { id: 'price_reduction', label: 'Réduction prix', icon: 'TrendingDown' },
  { id: 'sold_vehicle', label: 'Vendue', icon: 'CheckCircle' },
];

// Theme presets — curated color palettes for non-designers
// Each preset applies colors to config.colors (main 6 keys, badge colors stay independent)
export const THEME_PRESETS = [
  {
    id: 'default',
    name: 'Par défaut',
    desc: 'Couleurs du template',
    preview: null,
    colors: null, // uses template's built-in colors
  },
  {
    id: 'carmin-noir',
    name: 'Noir & Rouge Carmin',
    desc: 'Élégance sombre',
    preview: ['#0a0a0a', '#9B1B30', '#f0f0f0', '#555555'],
    colors: { background: '#0a0a0a', make: '#f0f0f0', model: '#f0f0f0', accent: '#9B1B30', catchphrase: '#777777', info: '#555555', badge_bg: '#9B1B30', badge_text: '#ffffff' },
  },
  {
    id: 'blanc-bleu',
    name: 'Blanc & Bleu',
    desc: 'Clarté professionnelle',
    preview: ['#f2f2ed', '#1e3a8a', '#1a1a2e', '#9ca3af'],
    colors: { background: '#f2f2ed', make: '#1a1a2e', model: '#1a1a2e', accent: '#1e3a8a', catchphrase: '#6b7280', info: '#9ca3af', badge_bg: '#1e3a8a', badge_text: '#ffffff' },
  },
  {
    id: 'bleu-orange',
    name: 'Bleu & Orange Carmin',
    desc: 'Nuit chaleureuse',
    preview: ['#0c1629', '#c45a28', '#e2e8f0', '#506380'],
    colors: { background: '#0c1629', make: '#e2e8f0', model: '#e2e8f0', accent: '#c45a28', catchphrase: '#7d8da6', info: '#506380', badge_bg: '#c45a28', badge_text: '#ffffff' },
  },
  {
    id: 'custom',
    name: 'Sur mesure',
    desc: 'Personnalisation libre',
    preview: null,
    colors: null, // unlocks individual color pickers
  },
];

